// A committed Calculator notice invalidates retained reads only; it never acquires data.
export interface CalculatorSocket {
  connected?: boolean;
  on(event: string, listener: (...args: any[]) => void): unknown;
  off(event: string, listener: (...args: any[]) => void): unknown;
}
export interface MackCalculatorChange {
  schema: 'mack_calculator_change_v1'; domain: 'TRADING'; agent: 'MACK'; panel: 'Calculator';
  read_route: '/api/mack/calculator'; producer_id: 'mack_calculator_5aa5282fe9d792d5c356';
  field_ids: ['mack.calculator.raw.GLOBAL.ofr_financial_stress'];
  material_hashes: string[]; change_id: string; revision_id: string;
  kind: 'EXACT_CALCULATOR_SOURCE_OBSERVATION';
}
const keys = ['schema', 'domain', 'agent', 'panel', 'read_route', 'producer_id', 'field_ids',
  'material_hashes', 'change_id', 'revision_id', 'kind'];
export function isMackCalculatorChange(detail: unknown): detail is MackCalculatorChange {
  if (!detail || typeof detail !== 'object' || Array.isArray(detail)) return false;
  const p = detail as Record<string, unknown>;
  return Object.keys(p).length === keys.length && keys.every(key => Object.prototype.hasOwnProperty.call(p, key)) &&
    p.schema === 'mack_calculator_change_v1' && p.domain === 'TRADING' && p.agent === 'MACK' &&
    p.panel === 'Calculator' && p.read_route === '/api/mack/calculator' &&
    p.producer_id === 'mack_calculator_5aa5282fe9d792d5c356' &&
    p.kind === 'EXACT_CALCULATOR_SOURCE_OBSERVATION' &&
    Array.isArray(p.field_ids) && p.field_ids.length === 1 &&
    p.field_ids[0] === 'mack.calculator.raw.GLOBAL.ofr_financial_stress' &&
    typeof p.change_id === 'string' && /^mack_calculator_ofr_change_[a-f0-9]{64}$/.test(p.change_id) &&
    p.revision_id === p.change_id && Array.isArray(p.material_hashes) && p.material_hashes.length > 0 &&
    p.material_hashes.every((value, index, values) => typeof value === 'string' && /^[a-f0-9]{64}$/.test(value) &&
      (index === 0 || values[index - 1] < value));
}

export function subscribeMackCalculatorChanges(socket: CalculatorSocket, reload: () => void,
  { reconnect = true }: { reconnect?: boolean } = {}): () => void {
  const seen = new Set<string>();
  let reconnectRead = socket.connected === false;
  const changed = (detail: unknown) => {
    if (!isMackCalculatorChange(detail) || seen.has(detail.change_id)) return;
    seen.add(detail.change_id);
    while (seen.size > 256) seen.delete(seen.values().next().value as string);
    reload();
  };
  const disconnected = () => { reconnectRead = true; };
  const connected = () => { if (reconnectRead) { reconnectRead = false; reload(); } };
  socket.on('mack_calculator_changed', changed);
  if (reconnect) {
    socket.on('disconnect', disconnected);
    socket.on('connect', connected);
  }
  return () => {
    socket.off('mack_calculator_changed', changed);
    if (reconnect) {
      socket.off('disconnect', disconnected);
      socket.off('connect', connected);
    }
  };
}
